<template>
    <div class="pa-4">
        <v-data-table :headers="headers" :items="items" class="elevation-1" :search="search">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Menu</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details />
                    <v-spacer />
                    <v-btn color="primary" dark class="mb-2" small @click="createMenu"
                        v-if="$store.state.currentPagePriv.create">
                        <v-icon small>mdi-plus</v-icon>
                        Add Menu
                    </v-btn>
                </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="viewData(item)">
                    mdi-eye
                </v-icon>
                <v-icon small class="mr-2" @click="editData(item)" v-if="$store.state.currentPagePriv.update">
                    mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)" v-if="$store.state.currentPagePriv.delete">
                    mdi-delete
                </v-icon>
                <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                        <v-card-title class="body-1 text-center">Anda akan menghapus data ini?</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                    Reset
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    data: () => ({
        dialogDelete: false,
        headers: [
            { text: 'Volume', value: 'volume_desc', sortable: false },
            { text: 'Menu Name', value: 'menu_name' },
            { text: 'Actions', value: 'actions', sortable: false }
        ],
        items: [],
        search: '',
    }),

    watch: {
        dialogDelete(val) {
            val || this.closeDelete()
        },
    },

    created() {
        this.initialize();
    },

    methods: {
        async initialize() {
            let response = await this.$store.dispatch('masterdatamenu/getObjs');
            if (response.data.status == 'success') {
                this.items = response.data.data;
            }
        },
        async createMenu() {
            this.$router.push('/master-data-menu/new');
        },
        viewData(item) {
            this.$router.push(`/master-data-menu/view/${item.code}`);
        },
        editData(item) {
            this.$router.push(`/master-data-menu/${item.code}`);
        },
        deleteItem(item) {
            this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        async deleteItemConfirm() {
            let url = this.$store.state.config.apiHost + "master-data-menu/" + this.editedItem.code
            let response = await this.$axios.delete(url, { headers: { 'Authorization': 'Bearer ' + this.$store.state.token, 'Content-Type': 'application/json' } })
            if (response.data.status == 'success') this.items.splice(this.editedIndex, 1)
            this.closeDelete()
        },
        closeDelete() {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },
    }
}
</script>